export default class EntrepriseMarcheInfosDto {
  entrepriseId;
  marcheId;
  pme;
  francilienne;
  agenceIdf;
  chiffreAffaire;
  chiffreAffaireInfolegale;
  anneeChiffreAffaire;
  effectif;
  effectifInfolegale;
  anneeEffectif;
  sourceApiDate;
  autonome;
  bilanTotal;
  bilanInfolegale
}